import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { consoleLog } from '../../services/common/utils';

const ExclusiveModal = (props, { type }) => {
    const navigate = useNavigate()
    const toggleModal = props.toggleModal;
    const {t} = useTranslation();
    const closeModal = () => {
        // console.log(`close modal...`);
        toggleModal();
    };

    const _appDeeplinkText = props.deeplinktext;

    const deeplinkclick = ()=>{
         const _url = getDeepLinkURL(_appDeeplinkText)
        consoleLog("app deeplink url:"+_url+"")
        if(_url != null && _url != undefined && _url != "")
            window.open(_url, '_blank');
    }

    const getDeepLinkURL= (deeplinktext)=>{
        switch (deeplinktext) {
            case 'networkproblem': {
             return ('https://app.ooredoo.com.kw/networkproblem');
              break;
            }
            case 'specialdeals': {
                return('https://app.ooredoo.com.kw/specialdeals');
              break;
            }
            case 'mycountry': {
                return('https://app.ooredoo.com.kw/mycountryviewall');
              break;
            }
            case 'roaming': {
                return('https://app.ooredoo.com.kw/roamingviewall');
              break;
            }
            case 'roamingdeals': {
              return('https://app.ooredoo.com.kw/roamingviewall');
            break;
          }
            case 'digitalservices': {
                return('https://app.ooredoo.com.kw/digitalservicesviewall');
              break;
            }
            case 'bundles': {
                return('https://app.ooredoo.com.kw/bundlesviewall');
              break;
            }
            case 'addons': {
                return('https://app.ooredoo.com.kw/addonsviewall');
              break;
            }
            case 'shop': {
                return('https://app.ooredoo.com.kw/shop');
              break;
            }
            case 'XpressProfit': {
                return('https://app.ooredoo.com.kw/paybill');
              break;
            }
            case 'Xpress Profit': {
                return('https://app.ooredoo.com.kw/paybill');
              break;
            }
            case 'recharge': {
                return('https://app.ooredoo.com.kw/recharge');
              break;
            }
            case 'help': {
                return('https://app.ooredoo.com.kw/help');
              break;
            }
            case 'viewbill': {
                return('https://app.ooredoo.com.kw/viewbill');
              break;
            }
            case 'nojoom': {
                return('https://app.ooredoo.com.kw/nojoom');
              break;
            }
            case 'esim': {
                return('https://app.ooredoo.com.kw/esimActivate');
              break;
            }
            case '/esimhome': {
                return('https://app.ooredoo.com.kw/esimActivate');
              break;
            }
            case 'internettransfer': {
                return('https://app.ooredoo.com.kw/InternetTransfer');
              break;
            }
            case 'requestcredit': {
                return('https://app.ooredoo.com.kw/creditselectoption');
              break;
            }
            case 'transfercredit': {
                return('https://app.ooredoo.com.kw/creditselectoption');
              break;
            }
            case 'paytransfercredits': {
                return('https://app.ooredoo.com.kw/creditselectoption');
              break;
            }
            case 'XpressProfit': {
                return('https://app.ooredoo.com.kw/paybill');
              break;
            }
            case 'smartPay': {
              return('https://app.ooredoo.com.kw/payhome');
            break;
            }
            default: {
                return("https://www.ooredoo.com.kw/getapp");
               

              break;
            }
          }
      }


    return <Modal show={props.show} backdrop="true" className='bottom_modal sp16-modal-bounce-effect' onHide={() => toggleModal()}>
        <Modal.Body className='text-center'>
            < h3 className="primary_16 mb-30">{t("featurenotavailable")}</h3 >
            <div className="text-center mx-auto" >
                {/* <h4 className='primary_14 primary_color mb-4 pointer' onClick={() => navigate('https://www.ooredoo.com.kw/getapp')}>Click here to download the app</h4> */}
                <a onClick={deeplinkclick} className='primary_14 primary_color mb-4 pointer d-block'>
                    {t("clkdownloadapp")}</a>
                <button type="button" className="custom_btn custom_btn_primary_outline me-2" 
                onClick={() => toggleModal()}>{t("Close")}</button>
            </div>
        </Modal.Body >
    </Modal >

}
export default ExclusiveModal;